import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import { CargueArchivosTramiteService } from '../services/cargue-archivos-tramite.service';
import { TipoAnexoTipoTramiteDto } from '../dto/tipo-anexo-tipo-tramite.dto';
import { TipoTramiteConstants } from '../../../../constants/tipo-tramite.constants';
import { ArchivoItemDto } from '../dto/ArchivoItemDto';
import { AnexoPrecargaResponseDto } from '../../../../dto/anexo/anexo-tramite.dto';
import { ArchivosTipoPreCargaDto } from './model/archivos-tipo.dto';
import {
  Subject,
  takeUntil,
  finalize,
  firstValueFrom,
  Subscription,
} from 'rxjs';
import { TramiteService } from '../../../../services/tramite.service';
import { Constants } from '../../../../constants/constants';
import { LanguageService } from '../../../../services/util/language.service';
import {AlertaModalService} from "../../../../services/util/alerta-modal.service";

@Component({
  selector: 'app-cargue-archivos-tramite',
  templateUrl: './cargue-archivos-tramite.component.html',
  styleUrl: './cargue-archivos-tramite.component.scss',
})
export class CargueArchivosTramiteComponent
  implements OnInit, OnChanges, OnDestroy {
  private destroy$ = new Subject<void>();
  loading = false;

  @Output() guardo = new EventEmitter<boolean>();
  @Output() archivosCargados = new EventEmitter<ArchivoItemDto[]>();
  @Output() archivosValidados = new EventEmitter<boolean>();
  @Output() archivosObligatoriosPasos = new EventEmitter<{ archivos: TipoAnexoTipoTramiteDto[]; paso: number }>();

  @Input() codigoPretencion?: string;
  @Input() paso?: number;
  @Input() idTipoTramite = 0;
  @Input() idTramite = 0;
  @Input() btnEnviar = false;
  @Input() enviar = false;
  @Input() enviarEntidad = false;
  @Input() reglaRequerido?: string;
  @Input() etiquetaBoton?: string = 'Continuar';
  @Input() nombreCortoTramite?: string = undefined;
  @Input() archivosPreCargados?: AnexoPrecargaResponseDto[] = [];
  @Input() validarObligatoriedadCargar?: boolean = false;
  @Input() reglaRequeridoEstricto?: boolean = false;
  @Input() cantidadMaxAchivos?: number;
  @Input() elminarArchivo = false;
  @Input() solicitante?: string;
  @Input() isRegistryEmpresa?: boolean;
  idiomaActual: string = 'es';

  listaAnexosTramites?: TipoAnexoTipoTramiteDto[] = [];
  listaArchivos: ArchivoItemDto[] = [];
  textoAdvertencia = '';
  archivosPorTipo?: ArchivosTipoPreCargaDto[] = [];

  private subscription: Subscription;
  private subscriptionRecarga: Subscription;

  isEmpresa: string = Constants.Empresa;
  constructor(
    private cargueArchivosTramiteService: CargueArchivosTramiteService,
    private tramiteService: TramiteService,
    private languageService: LanguageService,
    private alertService: AlertaModalService
  ) {
    // Se obtiene el tipo de reclamación seleccionado en la sección de reclamo directo -> formulario protección al consumidor
    this.subscription = this.cargueArchivosTramiteService.data$.subscribe(
      data => {
        if (data) {
          this.codigoPretencion = data;
        }
      }
    );

    // Se recarga el componente de acuerdo al evento del campo de tipo de reclamación -> formulario protección al consumidor
    this.subscriptionRecarga =
      this.cargueArchivosTramiteService.recargar$.subscribe(() => {
        this.recargarComponente();
      });
  }

  // Se recarga el componente y se vuelve a validar el requerido de los archivos
  recargarComponente() {
    if (this.archivosPorTipo) {
      if (this.codigoPretencion) {
        let json: any;

        if (typeof this.codigoPretencion === 'string') {
          json = JSON.parse(this.codigoPretencion);
        } else {
          json = this.codigoPretencion;
        }

        this.archivosPorTipo.forEach(anexo => {
          if (anexo.tipoAnexo.nombreAnexo === Constants.ANEXO_RECLAMACION) {
            if (json.tipoReclamacion === Constants.RECLAMACION_ESCRITA) {
              anexo.tipoAnexo.requerido = true;
            } else if (json.tipoReclamacion === Constants.RECLAMACION_VERBAL) {
              anexo.tipoAnexo.requerido = false;
            }
          }
          if (anexo.tipoAnexo.nombreAnexo === Constants.CONSTANCIA_RECLAMACION) {
            if (json.tipoReclamacion === Constants.RECLAMACION_VERBAL) {
              if (json.expidioConstancia == 'S') {
                anexo.tipoAnexo.requerido = true;
              } else if (json.expidioConstancia == 'N') {
                anexo.tipoAnexo.requerido = false;
              }
            }
          }
        });
      }
    }
  }

  ngOnInit() {
    this.getData();
    this.idiomaActual = this.languageService.getCurrentLanguage();
    this.languageService.currentLanguage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => {
        this.idiomaActual = lang;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    // Se valida para sic-procon paso 3
    if (changes['elminarArchivo']?.currentValue && this.idTipoTramite == Constants.SIC_PROCON) {
      this.eliminarTodoArchivo();
    }
    if (
      changes['enviar']?.currentValue &&
      (this.idTramite || changes['idTramite']?.currentValue) &&
      !this.btnEnviar
    ) {
      this.guardar();

    }
    if (this.paso) {
      if (this.idTipoTramite == Constants.SIC_PROCON) {
        // Servicio que recibe número del paso y reglas para traer archivos
        this.cargueArchivosTramiteService
          .getTipoArchivosTramitePasos(this.idTipoTramite, this.paso, this.codigoPretencion)
          .pipe(
            takeUntil(this.destroy$),
            finalize(() => (this.loading = false))
          )
          .subscribe({
            next: response => {
              if (Array.isArray(response)) {
                if (this.idTipoTramite == Constants.SIC_PROCON) {
                  if (this.codigoPretencion) {
                    let json: any;

                    if (typeof this.codigoPretencion === 'string') {
                      json = JSON.parse(this.codigoPretencion);
                    } else {
                      json = this.codigoPretencion;
                    }
                    response.forEach(anexo => {
                      // Si el tipo de reclamación es escrita y no recibió respuesta debe anexar: Documento de reclamación directa
                      if (json.tipoReclamacion === Constants.RECLAMACION_ESCRITA && json.recibioRespuesta == 'N') {
                        if (anexo.nombreAnexo === Constants.ANEXO_RECLAMACION) {
                          anexo.requerido = true;
                        }
                        if (anexo.nombreAnexo === Constants.CONSTANCIA_RECLAMACION) {
                          anexo.requerido = false;
                        }
                        if (anexo.nombreAnexo === Constants.RESPUESTA_RECLAMO) {
                          anexo.requerido = false;
                        }
                        return anexo;
                      }
                      // Si el tipo de reclamación es escrita y recibió respuesta debe anexar: Documento de reclamación directa y Respuesta del reclamo directo
                      if (json.tipoReclamacion === Constants.RECLAMACION_ESCRITA && json.recibioRespuesta == 'S') {
                        if (anexo.nombreAnexo === Constants.ANEXO_RECLAMACION) {
                          anexo.requerido = true;
                        }
                        if (anexo.nombreAnexo === Constants.RESPUESTA_RECLAMO) {
                          anexo.requerido = true;
                        }
                        if (anexo.nombreAnexo === Constants.CONSTANCIA_RECLAMACION) {
                          anexo.requerido = false;
                        }
                        return anexo;
                      }
                      // Si el tipo de reclamación es verbal y expidió constancia debe anexar: Constancia de la reclamación
                      if (json.tipoReclamacion === Constants.RECLAMACION_VERBAL && json.expidioConstancia == 'S') {
                        if (anexo.nombreAnexo === Constants.ANEXO_RECLAMACION) {
                          anexo.requerido = false;
                        }
                        if (anexo.nombreAnexo === Constants.RESPUESTA_RECLAMO) {
                          anexo.requerido = false;
                        }
                        if (anexo.nombreAnexo === Constants.CONSTANCIA_RECLAMACION) {
                          anexo.requerido = true;
                        }
                        return anexo;
                      }
                      // Si el tipo de reclamación es verbal y no expidió constancia no hay archivos requeridos
                      if (json.tipoReclamacion === Constants.RECLAMACION_VERBAL && json.expidioConstancia == 'N') {
                        if (anexo.nombreAnexo === Constants.ANEXO_RECLAMACION) {
                          anexo.requerido = false;
                        }
                        if (anexo.nombreAnexo === Constants.RESPUESTA_RECLAMO) {
                          anexo.requerido = false;
                        }
                        if (anexo.nombreAnexo === Constants.CONSTANCIA_RECLAMACION) {
                          anexo.requerido = false;
                        }
                        return anexo;
                      }
                    });
                  }
                }
                this.archivosObligatoriosPasos.emit({ archivos: response, paso: this.paso! })
                this.procesarTiposAnexos(response);
              }
            },
            error: error => {
              console.error('Error cargando tipos de archivos:', error);
            },
          });
      }
    }
  }

  getData() {
    this.loading = true;
    if (this.paso) {
      // Servicio que recibe número del paso y reglas para traer archivos
      this.cargueArchivosTramiteService
        .getTipoArchivosTramitePasos(this.idTipoTramite, this.paso, this.codigoPretencion, this.solicitante)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => (this.loading = false))
        )
        .subscribe({
          next: response => {
            if (Array.isArray(response)) {
              if (this.idTipoTramite == Constants.SIC_PROCON) {
                if (this.codigoPretencion) {
                  let json: any;

                  if (typeof this.codigoPretencion === 'string') {
                    json = JSON.parse(this.codigoPretencion);
                  } else {
                    json = this.codigoPretencion;
                  }
                  // Primera combinación: {tipoReclamacion: 'TR_E', recibioRespuesta: 'N'}
                  response.forEach(anexo => {
                    // Si el tipo de reclamación es escrita y no recibió respuesta debe anexar: Documento de reclamación directa
                    if (json.tipoReclamacion === Constants.RECLAMACION_ESCRITA && json.recibioRespuesta == 'N') {
                      if (anexo.nombreAnexo === Constants.ANEXO_RECLAMACION) {
                        anexo.requerido = true;
                      }
                      if (anexo.nombreAnexo === Constants.CONSTANCIA_RECLAMACION) {
                        anexo.requerido = false;
                      }
                      if (anexo.nombreAnexo === Constants.RESPUESTA_RECLAMO) {
                        anexo.requerido = false;
                      }
                      return anexo;
                    }
                    // Si el tipo de reclamación es escrita y recibió respuesta debe anexar: Documento de reclamación directa y Respuesta del reclamo directo
                    if (json.tipoReclamacion === Constants.RECLAMACION_ESCRITA && json.recibioRespuesta == 'S') {
                      if (anexo.nombreAnexo === Constants.ANEXO_RECLAMACION) {
                        anexo.requerido = true;
                      }
                      if (anexo.nombreAnexo === Constants.RESPUESTA_RECLAMO) {
                        anexo.requerido = true;
                      }
                      if (anexo.nombreAnexo === Constants.CONSTANCIA_RECLAMACION) {
                        anexo.requerido = false;
                      }
                      return anexo;
                    }
                    // Si el tipo de reclamación es verbal y expidió constancia debe anexar: Constancia de la reclamación
                    if (json.tipoReclamacion === Constants.RECLAMACION_VERBAL && json.expidioConstancia == 'S') {
                      if (anexo.nombreAnexo === Constants.ANEXO_RECLAMACION) {
                        anexo.requerido = false;
                      }
                      if (anexo.nombreAnexo === Constants.RESPUESTA_RECLAMO) {
                        anexo.requerido = false;
                      }
                      if (anexo.nombreAnexo === Constants.CONSTANCIA_RECLAMACION) {
                        anexo.requerido = true;
                      }
                      return anexo;
                    }
                    // Si el tipo de reclamación es verbal y no expidió constancia no hay archivos requeridos
                    if (json.tipoReclamacion === Constants.RECLAMACION_VERBAL && json.expidioConstancia == 'N') {
                      if (anexo.nombreAnexo === Constants.ANEXO_RECLAMACION) {
                        anexo.requerido = false;
                      }
                      if (anexo.nombreAnexo === Constants.RESPUESTA_RECLAMO) {
                        anexo.requerido = false;
                      }
                      if (anexo.nombreAnexo === Constants.CONSTANCIA_RECLAMACION) {
                        anexo.requerido = false;
                      }
                      return anexo;
                    }
                  });
                }
              }
              this.archivosObligatoriosPasos.emit({ archivos: response, paso: this.paso! })
              this.procesarTiposAnexos(response);
            }
          },
          error: error => {
            console.error('Error cargando tipos de archivos:', error);
          },
        });
    } else if (this.isRegistryEmpresa) {
      this.cargueArchivosTramiteService
        .getTipoArchivosEmpresaPublico()
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => (this.loading = false))
        )
        .subscribe({
          next: response => {
            if (Array.isArray(response)) {
              this.procesarTiposAnexos(response);
            }
          },
          error: error => {
            console.error('Error cargando tipos de archivos:', error);
          },
        });
    } else {
      this.cargueArchivosTramiteService
        .getTipoArchivosTramite(this.idTipoTramite, this.codigoPretencion)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => (this.loading = false))
        )
        .subscribe({
          next: response => {
            if (Array.isArray(response)) {
              this.procesarTiposAnexos(response);
            }
          },
          error: error => {
            console.error('Error cargando tipos de archivos:', error);
          },
        });
    }
  }

  private procesarTiposAnexos(response: TipoAnexoTipoTramiteDto[]) {
    this.listaAnexosTramites = response;
    if (
      this.idTipoTramite === TipoTramiteConstants.ID_TRAMITE_SIC_PROIND_COMDES
    ) {
      this.listaAnexosTramites = this.listaAnexosTramites.map(elemento => ({
        ...elemento,
        tipoAnexo: {
          ...elemento.tipoAnexo,
          tamanoMax: Number(elemento?.tipoAnexo?.tamanoMax) ,
        },
      }));
    }

    this.archivosPorTipo = this.listaAnexosTramites.map(tipoTramite => ({
      tipoAnexo: tipoTramite,
      archivosPreCargados: this.archivosPreCargados?.filter(
        files => files.tipoAnexoTipoTramite.id === tipoTramite.id
      ),
    }));

    if (this.idTipoTramite == Constants.SIC_PROCON) {
      if (this.codigoPretencion) {
        let json: any;

        if (typeof this.codigoPretencion === 'string') {
          json = JSON.parse(this.codigoPretencion);
        } else {
          json = this.codigoPretencion;
        }

        this.archivosPorTipo.forEach(anexo => {
          if (anexo.tipoAnexo.nombreAnexo === Constants.ANEXO_RECLAMACION) {
            if (json.tipoReclamacion === Constants.RECLAMACION_ESCRITA) {
              anexo.tipoAnexo.requerido = true;
            } else if (json.tipoReclamacion === Constants.RECLAMACION_VERBAL) {
              anexo.tipoAnexo.requerido = false;
            }
            if (anexo.tipoAnexo.nombreAnexo === Constants.CONSTANCIA_RECLAMACION) {
              if (json.tipoReclamacion === Constants.RECLAMACION_VERBAL) {
                if (json.expidioConstancia == 'S') {
                  anexo.tipoAnexo.requerido = true;
                } else if (json.expidioConstancia == 'N') {
                  anexo.tipoAnexo.requerido = false;
                }
              }
            }
          }
        });
      }
    }
  }

  async guardar() {
    const todosRequeridosConArchivo = this.validarArchivosRequeridos();

    if (this.enviarEntidad) {
      if (!todosRequeridosConArchivo) {
        if (this.paso == undefined) {
          this.guardo.emit(false);
          return;
        } else {
          return;
        }
      }
    }

    try {
      const resultados = await Promise.all(
        this.listaArchivos.map(async obj => {
          const idTipoAnexo = obj.item.tipoAnexo?.id?.toString() || '';
          const archivosNoCargados = await this.getValidFiles(
            obj.files,
            this.archivosPorTipo?.find(
              archivos => archivos.tipoAnexo.id === obj.item.id
            )?.archivosPreCargados
          );

          return Promise.all(
            archivosNoCargados.map(async file => {
              const formData = new FormData();
              formData.append(
                'archivos',
                this.renombarArchivo(file, `${idTipoAnexo}-${file.name}`)
              );
              try {
                const response = await firstValueFrom(
                  this.cargueArchivosTramiteService.guardarArchivos(
                    this.idTramite,
                    obj.item.id!,
                    formData
                  )
                );
                if (response.status === 400) {
                  this.alertService.error(response.mensaje);
                  return false;
                }
                return response.status === 200;
              } catch {
                return false;
              }
            })
          );
        })
      );

      const todoExitoso = resultados.flat().every(Boolean);
      if (todoExitoso && this.enviarEntidad) {
        try {
          const response = await firstValueFrom(
            this.tramiteService.envioAEntidad(this.idTramite, this.nombreCortoTramite, this.idiomaActual)
          );
          this.guardo.emit(true);
        } catch (error) {
          this.guardo.emit(false);
        }
      }
      this.guardo.emit(todoExitoso);
    } catch (error) {
      console.error('Error al guardar archivos:', error);
      this.guardo.emit(false);
    }
  }

  cargar(item: TipoAnexoTipoTramiteDto, files: File[]): void {
    const existingEntry = this.listaArchivos.find(entry => entry.item === item);

    if (existingEntry) {
      const nuevosArchivos = files.filter(
        file =>
          !existingEntry.files.some(
            existingFile => existingFile.name === file.name
          )
      );
      existingEntry.files.push(...nuevosArchivos);
    } else {
      this.listaArchivos.push({ item, files });
    }

    this.archivosCargados.emit(this.listaArchivos);
    this.validarArchivosRequeridos();
  }

  mostrarComponente(tipo: TipoAnexoTipoTramiteDto): boolean {
    const regla = tipo.reglaRequerido;

    // Si la regla no es nula, indefinida o vacía, y está incluida en `regla`, muestra el componente
    if (
      (regla?.trim() && regla.includes(this.reglaRequerido ?? '')) ||
      (!this.reglaRequeridoEstricto && !regla)
    ) {
      return true;
    }

    // Si la regla no se cumple, no muestra el componente
    return false;
  }

  validateFileContent(file: File): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const content = reader.result as string;
        resolve(content.trim().length > 0);
      };
      reader.onerror = () => {
        reject(new Error('Error leyendo el archivo.'));
      };
      reader.readAsText(file);
    });
  }

  async getValidFiles(
    files: File[],
    archivosYaCargados?: AnexoPrecargaResponseDto[]
  ): Promise<File[]> {
    let archivosNoCargados = files;
    if (archivosYaCargados && archivosYaCargados.length > 0) {
      archivosNoCargados = files.filter(
        file =>
          !archivosYaCargados.some(
            archivo =>
              archivo.nombreArchivo == file.name &&
              Number(archivo.tamano) == file.size
          )
      );
    }
    const validationResults = await Promise.all(
      archivosNoCargados.map(async file => ({
        file,
        isValid: await this.validateFileContent(file),
      }))
    );
    return validationResults
      .filter(result => result.isValid)
      .map(result => result.file);
  }

  renombarArchivo(archivo: File, nuevoNombre: string): File {
    return new File([archivo], nuevoNombre, {
      type: archivo.type,
      lastModified: archivo.lastModified,
    });
  }

  validarArchivosRequeridos() {
    this.textoAdvertencia = '';
    // Filtrar los ítems que se están renderizando
    const listaFiltrada = this.archivosPorTipo?.filter(item =>
      this.mostrarComponente(item.tipoAnexo)
    );

    const todosRequeridosConArchivo = listaFiltrada?.every(item => {
      if (item.tipoAnexo.requerido) {
        return this.listaArchivos.some(entry => {
          return (
            entry.item?.id === item.tipoAnexo?.id &&
            entry.files.length > 0
          );
        });
      }
      return true;
    });

    if (!todosRequeridosConArchivo) {
      this.textoAdvertencia =
        'Debe adjuntar archivos para todos los campos requeridos.';
      this.guardo.emit(false);
      if (this.paso == undefined) {
        this.textoAdvertencia =
          'Debe adjuntar archivos para todos los campos requeridos.';
        this.guardo.emit(false);
      }
    } else if (this.validarObligatoriedadCargar) {
      this.guardo.emit(true);
    }
    this.archivosValidados.emit(todosRequeridosConArchivo);
    return todosRequeridosConArchivo;
  }

  eliminar(item: TipoAnexoTipoTramiteDto, archivo: File): void {
    const entradaArchivo = this.listaArchivos.find(
      entry => entry.item === item
    );

    if (entradaArchivo) {
      // Eliminar el archivo específico del array de archivos
      const index = entradaArchivo.files.findIndex(
        file => file.name === archivo.name && file.size === archivo.size
      );

      if (index !== -1) {
        entradaArchivo.files.splice(index, 1);

        // Si no quedan archivos, eliminar la entrada completa
        if (entradaArchivo.files.length === 0) {
          const entradaIndex = this.listaArchivos.indexOf(entradaArchivo);
          this.listaArchivos.splice(entradaIndex, 1);
        }

        if (this.idTramite) {
          this.cargueArchivosTramiteService
            .eliminarArchivos(
              this.idTramite,
              item?.tipoAnexo?.id!,
              archivo.name
            )
            .subscribe(data => { });
        }

        // Emitir la lista actualizada
        this.archivosCargados.emit(this.listaArchivos);

        // Validar archivos requeridos después de eliminar
        this.validarArchivosRequeridos();
      }
    }
  }

  eliminarTodoArchivo() {
    this.listaArchivos = [];
    this.archivosCargados.emit([]);
    this.archivosValidados.emit(false);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription.unsubscribe();
    this.subscriptionRecarga.unsubscribe();
  }

}
